// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"578":"162e4f3a","785":"7bc302eb"}[chunkId] + ".chunk.js";
};